import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { UserNotificationsDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/user-notification`;

export const getNewNotifications = (
    lastReadNotificationId: number | undefined)
    : Promise<UserNotificationsDto> => {

  return axios.get(
          `${apiUri}`,
          {
            params: {
              lastReadNotificationId: lastReadNotificationId || 0
            }
          })
      .then(result => result.data);
};

export const removeNotification = (
    notificationId: number,
    cancelTokenSource: CancelTokenSource)
    : Promise<void> => {

  return axios.delete(
          `${apiUri}/${notificationId}`,
          {
            cancelToken: cancelTokenSource.token
          })
      .then(result => {
      });
};
